import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { Text } from "src/components/ui/Text";
import AccordionInfoDetails from "./AccordionInfoDetails";
import {
  ModalVehicleIcon,
  ModalChargerIcon,
  BatteryTypeIcon,
  BatteryCapacityIcon,
  RatedPowerIcon,
  MaxSpeedIcon,
  MaxDistanceIcon,
  ChargingTypeIcon,
  AddIcon,
  MinusIcon,
  OutputPowerIcon,
  StartModeIcon,
} from "../icons";
import { useTranslation } from 'react-i18next'

const AccordionInfo = ({
  information,
  index,
  infoView,
  showInfo,
  groupSelectStatus,
  selectedRange,
}) => {
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation("settings");

  return (
    <Accordion
      sx={{
        boxShadow: "none",
        border: 1,
        borderColor: "#E5E5E5",
        borderRadius: "8px !important",
      }}
      onChange={(_, expanded) => {
        setExpanded(expanded);
      }}
      disabled={!showInfo}
    >
      <AccordionSummary
        aria-controls={`panel${index + 1}-content`}
        id={`panel${index + 1}-header`}
        sx={{
          padding: "0px 8px",
          bgcolor: "#F2F8F6",
          borderRadius: expanded ? "8px 8px 0px 0px" : "8px",
          height: "54px",
          "&.Mui-expanded": {
            minHeight: "54px",
          },
        }}
      >
        <div className="flex gap-2">
          <div>{expanded && showInfo ? <MinusIcon /> : <AddIcon />}</div>
          <div>
            <Text variant="semi-14" className="text-primary">
              {information?.device}
            </Text>
            <Text variant="medium-10" className={"text-primary"}>
              {`${t('report.total_status')} : ${information?.record} ${Number(information?.record) > 1 ? t('report.records') : t('report.record')}`}
            </Text>
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: "0px" }}>
        {/* Vehicle information */}
        {expanded && showInfo ? (
          <AccordionInfoDetails
            id={information?.id}
            infoView={infoView}
            groupSelectStatus={groupSelectStatus}
            informationIconLists={
              infoView === "truck"
                ? vehicleInformationIconLists
                : stationInformationIconLists
            }
            selectedRange={selectedRange}
          />
        ) : (
          ""
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionInfo;

const vehicleInformationIconLists = [
  { name: "Model", icon: <ModalVehicleIcon /> },
  { name: "Battery Type", icon: <BatteryTypeIcon /> },
  { name: "Battery Capacity", icon: <BatteryCapacityIcon /> },
  { name: "Rated Power", icon: <RatedPowerIcon /> },
  { name: "Max Speed", icon: <MaxSpeedIcon /> },
  { name: "Max Distance", icon: <MaxDistanceIcon /> },
  { name: "Charging Type", icon: <ChargingTypeIcon /> },
];

const stationInformationIconLists = [
  { name: "Model", icon: <ModalChargerIcon /> },
  { name: "Output Power", icon: <OutputPowerIcon /> },
  { name: "Charging Type", icon: <ChargingTypeIcon /> },
  { name: "Start Mode", icon: <StartModeIcon /> },
];
